import { useHyperTestProjectName } from 'hooks/HypertestJobDetail/useHyperTestProjectName';
import { LTTooltip, LTButton } from '@lambdatestincprivate/lt-components';
import LTText from 'components/LTComponents/LTText/LTText';
import { Link } from 'react-router-dom';
import { Path } from 'constants/routes';
import './index.css';

function HeaderTitle() {
  const {
    showProjectName,
    fullProjectName,
    truncatedProjectName,
    exceedsCharLimit,
    projectId,
  } = useHyperTestProjectName();

  if (!showProjectName) {
    return 'HyperExecute';
  }

  const renderProjectName = (name) => {
    if (projectId) {
      return (
        <Link
          className="hyp-common-header-title-link"
          to={`${Path.PROJECT_DETAILS}?projectId=${projectId}`}
          style={{
            color: '#1f2328',
            textDecoration: 'none',
            cursor: 'pointer',
          }}
        >
          {name}
        </Link>
      );
    }
    return name;
  };

  if (exceedsCharLimit) {
    return (
      <LTTooltip
        className="hyp-common-header-title"
        text={`${fullProjectName}`}
      >
        <LTText
          color="#1f2328"
          size={14}
          weight={600}
          lineHeight={20}
          as="span"
        >
          <span className="hyp-common-header-title-text">{`HyperExecute / `}</span>
          {renderProjectName(truncatedProjectName)}
        </LTText>
      </LTTooltip>
    );
  }

  return (
    <LTText color="#1f2328" size={14} weight={600} lineHeight={20} as="span">
      <span className="hyp-common-header-title-text">{`HyperExecute / `}</span>
      {renderProjectName(fullProjectName)}
    </LTText>
  );
}

export default HeaderTitle;
